import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs' ;
import { CustomerService } from '../../../services/customer.service';
import { mapTo, mergeMap } from 'rxjs/operators';
import { Customer } from '../../../models/Customer';

@Injectable()
export class CurrentCustomerResolver implements Resolve<Customer> {

    constructor(
        private customerService: CustomerService
    ) { }

    resolve(): Observable<Customer> {
        return this.customerService.getCustomer().pipe(
            mergeMap(customer => this.customerService.getCustomerSettings(customer.id).pipe(mapTo(customer)))
        );
    }

}
